import React, { Component } from 'react';

class Pagination extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  getTotalPages() {
    const { rowsPerPage, totalRows } = this.props;
    return Math.ceil(totalRows / rowsPerPage);
  }

  pageRange(pageNumbers) {
    const { setCurrentPage, currentPage } = this.props;

    const rangeStart = currentPage - 2;
    const rangeEnd = currentPage + 2;

    const range = pageNumbers.filter(function(x) {
      return x >= rangeStart && x <= rangeEnd;
    });

    return (
      <div className="pagination">
        <ul>
          {currentPage > 1 && (
            <li onClick={() => setCurrentPage(currentPage - 1)}>
              {'<'}
            </li>
          )}
          {range.map(number => (
            <li onClick={() => setCurrentPage(number)} key={number} className={currentPage === number ? 'active' : ''}>
              {number}
            </li>
          ))}
          {currentPage < this.getTotalPages() && (
            <li onClick={() => setCurrentPage(currentPage + 1)}>
              {'>'}
            </li>
          )}
        </ul>
      </div>
    );
  }

  render() {
    const { rowsPerPage, totalRows, setCurrentPage, currentPage } = this.props;
    const pageNumbers = [];

    for (let i = 1; i <= Math.ceil(totalRows / rowsPerPage); i++) {
      pageNumbers.push(i);
    }

    if (this.getTotalPages() > 5) {
      return (this.pageRange(pageNumbers));
    }

    return (
      <div className="pagination">
        <ul>
          {pageNumbers.map(number => (
            <li onClick={() => setCurrentPage(number)} key={number} className={currentPage === number ? 'active' : ''}>
              {number}
            </li>
          ))}
        </ul>
      </div>
    );
  }
}

export default Pagination;
